export default __webpack_public_path__ + "static/media/IC6-Integration.7a6b46d8.png";